<template>
    <div class="tooltip-wings" @mouseover="mouseover" @mouseleave="mouseleave" @click="mouseover">
        <slot name="switch"><md-icon>help_outline</md-icon></slot>
        <zoom-center-transition>
            <div class="tooltip-wings__content" v-if="show"><slot></slot></div>
        </zoom-center-transition>
    </div>
</template>

<script>
  import { ZoomCenterTransition } from "vue2-transitions";
  export default {
    name: "TooltipWings",
    components:{ZoomCenterTransition},
    data(){return{
      show: false,
    }},
    methods: {
      mouseover(){
        this.show = true
      },
      mouseleave(){
        this.show = false
      }
    }
  }
</script>

<style lang="scss">
    .tooltip-wings{
        display: inline-block;
        position: relative;
        .md-icon{
            width: 16px;
            min-width: 16px;
            height: 16px;
            font-size: 16px!important;
            color: #bfbebe !important;
            transform: translateY(-1px);
        }
    }
    .tooltip-wings__content{
        position: absolute;
        top: 100%;
        font-size: 0.8em;
        background: #fff;
        /*color: #fff;*/
        border-radius: 3px;
        padding: 5px 10px 4px;
        z-index: 100;
        text-align: left;
        min-width: 300px;
        box-shadow: 1.414px 1.414px 3.92px 0.08px rgba(0, 0, 0, 0.15);
    }

    .md-form-label{
        position: relative;
        .tooltip-wings{
            position: absolute;
            left: 100%;
            margin-left: -4px;
        }
    }
</style>